/**
 * Enables search to work in the select search control
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/manipulation/empty/empty.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/dimensions/scroll/scroll.js";
import "dabbyjs/src/events/trigger/trigger.js";
import "dabbyjs/src/manipulation/text/text.js";
import "dabbyjs/src/attributes/prop/prop.js";

export default (obj, cls) => {
	obj.each(function () {
		let $this = $(this),
			input = $(cls+"-search-input", $this),
			value = $(cls + "-value", $this),
			href = input.data("callback"),
			timer;

		// get search suggestions
		input.on("keyup", e => {
			const val = input.val(),
				loading = cls + "-search-input--loading";

			if (val !== $this.data("last-value")) {
				input.addClass(loading);
				window.clearTimeout(timer);
				timer = window.setTimeout(() => {
					fetch(href + "&ss=" + encodeURIComponent(val), {headers: {accept: "text/html"}})
						.then(response => response.text())
						.then(html => {
							$(cls+"-results", $this).empty().append(html).scrollTop(0);
							input.removeClass(loading);
						});
				}, e.key === "Enter" ? 1 : 500);
			}
			$this.data("last-value", val);

		// cancel enter button submitting form on search box
		}).on("keypress", (e) => {
			if (e.key === "Enter") {
				return false;
			}
		});

		// select an item;
		$this.on("click", "li[data-id]", function () {
			const self = $(this);
			value.val(self.data("id")).trigger("change");
			$(cls + "-label", $this).text(self.text());
			$(cls + "-switch", $this).prop("checked", "");
		});
	});
};
